var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('q-translate',{attrs:{"placeholder":"現在アカウントが休止中です。再開される場合は、Vivo事務局までお問い合わせください。","text-key":"hall-0240"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }